module.exports = __webpack_public_path__ + "assets/roboto-v30-latin_latin-ext-italic.6ea4251c9c01964ee1e8dd04b4d3dd85.woff2";